var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.52677C2.37362 -0.839827 14 -1.00055 16 7.52677M12.25 8.15172C12.25 10.2228 10.5711 11.9017 8.5 11.9017C6.42893 11.9017 4.75 10.2228 4.75 8.15172C4.75 6.08065 6.42893 4.40172 8.5 4.40172C10.5711 4.40172 12.25 6.08065 12.25 8.15172Z",
    stroke: "#626262",
    strokeWidth: 1.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.9583,
    y1: 0.386979,
    x2: 1.31662,
    y2: 13.1847,
    stroke: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.f8bc97a4e003ef01af277353a66264db.svg";
export { ForwardRef as ReactComponent };